// ============================================
// MissionControl/MissionControl.constants.js
// ============================================

export const MISSION_TIERS = {
  SIMPLE: 'simple',
  COMPLEX: 'complex',
  CAMPAIGN: 'campaign',
};

export const MISSION_MODES = {
  AUTO: 'auto',
  MANUAL: 'manual',
};

export const DEPLOYMENT_STATUS = {
  ON_MISSION: 'On Mission',
  ACTIVE: 'Active',
  COMPLETED: 'Completed',
};

// Default theme fallback
export const DEFAULT_THEME = 'vanilla';

// Default values
export const DEFAULT_THREAT_LEVEL = 3;
export const MAX_THREAT_LEVEL = 10;

// Mission type badges configuration
export const MISSION_TYPE_BADGES = {
  [MISSION_TIERS.SIMPLE]: {
    className: 'bg-green-900/20 border border-green-500 text-green-400',
    defaultLabel: 'AUTO ONLY',
  },
  [MISSION_TIERS.COMPLEX]: {
    className: 'bg-yellow-900/20 border border-yellow-500 text-yellow-400',
    defaultLabel: 'AUTO OR MANUAL',
  },
  [MISSION_TIERS.CAMPAIGN]: {
    className: 'bg-red-900/20 border border-red-500 text-red-400',
    defaultLabel: 'MANUAL ONLY',
  },
};

// Default labels for theming
export const DEFAULT_LABELS = {
  missionControl: {
    title: 'Mission Control',
    subtitle: 'Deploy your squad on tactical operations',
    threatLabel: 'THREAT LEVEL',
    activeLabel: 'Active Missions',
    deployedLabel: 'soldiers deployed',
    successLabel: 'SUCCESS',
    failedLabel: 'FAILED',
    simpleTier: 'SIMPLE MISSIONS',
    complexTier: 'COMPLEX MISSIONS',
    campaignTier: 'CAMPAIGN MISSIONS',
    autoOnly: 'AUTO ONLY',
    autoOrManual: 'AUTO OR MANUAL',
    manualOnly: 'MANUAL ONLY',
    squadRequirement: 'SQUAD REQUIREMENT',
    soldiersLabel: 'soldiers',
    unlocksLabel: 'Unlocks on Day',
    daysLabel: 'days',
    rewardsLabel: 'REWARDS',
    risksLabel: 'RISKS',
    casualtyLabel: 'Casualty',
    chooseModeLabel: 'Choose Mission Mode',
    autoResolveTitle: 'AUTO RESOLVE',
    autoResolveDesc: 'Mission resolves automatically when the day advances.',
    manualControlTitle: 'MANUAL CONTROL',
    manualControlDesc: 'Full tactical control on the battlefield. Higher risk, higher reward.',
    selectSquadLabel: 'Select Squad Members',
    requiredLabel: 'required',
    noSoldiersLabel: 'No soldiers available for deployment',
    deployAutoButton: 'DEPLOY (AUTO)',
    deployManualButton: 'DEPLOY TO BATTLE',
    cancelButton: 'CANCEL',
  },
  resources: {
    intel: 'Intel',
    supplies: 'Supplies',
  },
};

// Icon sizes
export const ICON_SIZES = {
  SMALL: 14,
  MEDIUM: 16,
  LARGE: 18,
  XL: 20,
  XXL: 24,
  XXXL: 32,
  HUGE: 48,
};

// Grid layouts
export const GRID_LAYOUTS = {
  MISSION_CARDS: 'grid-cols-2',
  MODE_SELECTION: 'grid-cols-2',
  REWARDS_RISKS: 'grid-cols-2',
};